import axios from 'axios'
export default{
  
    change(msg){
        this.msg = msg;
        console.log(this.msg,"+++时间数据")
     },
      open2() {
        this.$alert('您选择的参数有误', '提示信息', {
          confirmButtonText: '确定',
          callback: action => {
            this.$message({
              type: 'info',
              message: `action: ${ action }`
            });
          }
        });
      },
    search(){
          
          if(this.smeltPSele==""||this.msg.start==undefined||this.msg.end==undefined){
             //this.$options.methods.open()     //在serach方法中调用open方法
             this.$alert('您必须选择时间和冶炼厂才可查询数据。', '提示信息', {
              confirmButtonText: '确定',
              callback: action => {
                console.log("123")    //回调函数
                // this.$message({
                //   type: 'info',
                //   message: `action: ${ action }`
                // });
              }
          });
          }else{
                
                axios({
                method:"POST",
                url:this.urls+"/funding/searchStockTotalByOwner",
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                  'Content-Type': 'application/json; charset=UTF-8'
                },
                data:{
                      "searchType":4,
                      "pageSize":"12",
                      "pageNumber":this.pageNo,
                      "saCustId":this.smeltPSele,
                      "startDate":this.msg.start,
                      "endDate":this.msg.end,
                      "token":this.token
                    }
            })
            .then((res)=>{
              console.log(this.axios);
              console.log(res.data);
              this.smeltData = res.data.page.rows;
             this.actualAmount = res.data.actualAmount;
              //this.actualAmount = ((res.data.actualAmount)/1000).toFixed(2);
              this.pageAll = Math.ceil((res.data.page.total)/12);
              this.smeltInfo = true;
            }) 
            .catch((err)=>{
              console.log(err);
            })
        }
           
     },
       //冶炼厂++
    smeltShow(){
         this.smelting = true;
         this.infoDate = true;
         this.pageNo = 1;
         this.pageAll = 1;
         this.searchType = 4; 
         this.infoDate = true; 
            if(this.smeltInfo==true){
                this.smeltData = this.smeltData;
                console.log("++++")
            }else if(this.smeltInfo==false){
                console.log(this.smeltData)
                this.smeltData = "";
                
                console.log(this.smelting,"12",this.msg);
                axios({
                  method:"POST",
                  url:this.urls+"/funding/getSaCustomer",
                  headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json; charset=UTF-8'
                  },
                data:{
                        "searchType":4, 
                        "token":this.token
                      }
                })
                .then((res)=>{
                    console.log(res.data);
                    this.smeltPlants =  res.data;
                })
                .catch((err)=>{
                    console.log(err)
                }) 
            } 
            
         
         
         
      },
    selectSmelt(){
          console.log(this.smeltPSele,"xuanzhong");
         
      },
      //仓库++
    warehouse(){
        this.pageNo = 1;
        this.pageNo = 1
        this.searchType=2;
        this.smelting = false;
        this.smeltInfo = false;
        this.infoDate = false; 
        this.smeltPSele = "";
        console.log(this.msg.end,"自组建传递过来的++")
         axios({
          method:"POST",
          url:this.urls+"funding/searchStockTotalByOwner",
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json; charset=UTF-8'
          },
         data:{
                "searchType":2,
                "pageSize" : 12,
                "pageNumber":this.pageNo,
                "token":this.token
                }
        })
        .then((res)=>{
          console.log(res);
          this.smeltData =  res.data.page.rows;
          this.pageAll = Math.ceil((res.data.page.total)/12)
        })
        .catch((err)=>{
          console.log(err)
        })
      },
   //运输中++ 类型为1
    branch(){
      this.pageNo = 1;
         this.pageNo = 1
         this.searchType=1;
         this.smelting = false;
         this.smeltInfo = false;
         this.smeltPSele = "";
         this.infoDate = false; 
         axios({
          method:"POST",
          url:this.urls+"funding/searchStockTotalByOwner",
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json; charset=UTF-8'
          },
          data:{
                "searchType":1,
                "pageSize" : 12,
                "pageNumber":this.pageNo,
                "token":this.token
                }
        })
        .then((res)=>{
          console.log(res);
           this.smeltData =  res.data.page.rows;
           this.pageAll = Math.ceil((res.data.page.total)/12)
        })
        .catch((err)=>{
          console.log(err)
        })
     },
    artery(){
       this.pageNo = 1;
       this.pageNo = 1
       this.smelting = false;
       this.smeltInfo = false;
       this.searchType=3;
       this.smeltPSele = "";
       this.infoDate = false; 
        axios({
          method:"POST",
          url:this.urls+"funding/searchStockTotalByOwner",
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json; charset=UTF-8'
          },
         data:{
                "searchType":3,
                "pageSize" : 12,
                "pageNumber":this.pageNo,
                "token":this.token
                }
        })
        .then((res)=>{
          console.log(res);
           this.smeltData =  res.data.page.rows;
           this.pageAll = Math.ceil((res.data.page.total)/12)
        })
        .catch((err)=>{
          console.log(err)
        })
     },
     prve(){
       this.pageNo--;
       if(this.pageNo<1){
            this.$alert('没有更多数据了。', '提示信息', {
                confirmButtonText: '确定',
                callback: action => {
                  console.log("123")    //回调函数
                  // this.$message({
                  //   type: 'info',
                  //   message: `action: ${ action }`
                  // });
              }
          });
          this.pageNo = 1
       }else if(this.searchType==4){
            this.infoDate = true;
           axios({
                method:"POST",
                url:this.urls+"/funding/searchStockTotalByOwner",
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                  'Content-Type': 'application/json; charset=UTF-8'
                },
                data:{
                      "searchType":4,
                      "pageSize":"12",
                      "pageNumber":this.pageNo,
                      "saCustId":this.smeltPSele,
                      "startDate":this.msg.start,
                      "endDate":this.msg.end,
                      "token":this.token
                    }
            })
            .then((res)=>{
              console.log(this.axios);
              console.log(res.data);
              this.smeltData = res.data.page.rows;
             this.actualAmount = res.data.actualAmount;
              //this.actualAmount = ((res.data.actualAmount)/1000).toFixed(2);
              this.pageAll = Math.ceil((res.data.page.total)/12)
            }) 
            .catch((err)=>{
              console.log(err);
            })
       }else{
          axios({
            method:"POST",
            url:this.urls+"funding/searchStockTotalByOwner",
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/json; charset=UTF-8'
            },
          data:{
                  "searchType":this.searchType,
                  "pageSize" : 12,
                  "pageNumber":this.pageNo,
                  "token":this.token
                  }
          })
          .then((res)=>{
            console.log(res);
            this.smeltData =  res.data.page.rows;
          })
          .catch((err)=>{
            console.log(err)
          })
       }
     },
     next(){
       this.pageNo++;
       if(this.pageNo>this.pageAll){
            this.$alert('没有更多数据了。', '提示信息', {
              confirmButtonText: '确定',
              callback: action => {
                console.log("123")    //回调函数
                // this.$message({
                //   type: 'info',
                //   message: `action: ${ action }`
                // });
              }
          });
          this.pageNo = this.pageAll
       }else if(this.searchType==4){
             this.infoDate = true;
             axios({
                method:"POST",
                url:this.urls+"/funding/searchStockTotalByOwner",
                headers: {
                  'X-Requested-With': 'XMLHttpRequest',
                  'Content-Type': 'application/json; charset=UTF-8'
                },
                data:{
                      "searchType":4,
                      "pageSize":"12",
                      "pageNumber":this.pageNo,
                      "saCustId":this.smeltPSele,
                      "startDate":this.msg.start,
                      "endDate":this.msg.end,
                      "token":this.token
                    }
            })
            .then((res)=>{
              console.log(this.axios);
              console.log(res.data);
              this.smeltData = res.data.page.rows;
             this.actualAmount = res.data.actualAmount;
              //this.actualAmount = ((res.data.actualAmount)/1000).toFixed(2);
              this.pageAll = Math.ceil((res.data.page.total)/12)
            }) 
            .catch((err)=>{
              console.log(err);
            })
       }else{
          axios({
            method:"POST",
            url:this.urls+"funding/searchStockTotalByOwner",
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/json; charset=UTF-8'
            },
          data:{
                  "searchType":this.searchType,
                  "pageSize" : 12,
                  "pageNumber":this.pageNo,
                  "token":this.token
                  }
          })
          .then((res)=>{
            console.log(res);
            this.smeltData =  res.data.page.rows;
          })
          .catch((err)=>{
            console.log(err)
          })
       }
     },
   
  freshCapAll(){
        console.log("测试一下会不会执行+++",this.token);
        axios({
          method:"POST",
          url:this.urls+"/funding/getfundingStatistical",
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json; charset=UTF-8'
          },
          data:{
                "token":this.token,
              }
      })
      .then((res)=>{
          this.capital = res.data;
      }) 
      .catch((err)=>{
        console.log(err);
      })
  },
  freshCap(){
    this.fresh = true;
    this.noFresh = false;
    this.$options.methods.freshCapAll();
    //setTimeout(function(){this.fresh = true},1500);
   setTimeout(() => {  
      this.fresh = false;  
      this.noFresh = true;
    }, 1200);
  }

}


// WEBPACK FOOTER //
// ./src/homeDataMethods/homeMethods.js